export default {
  vermelho: '#c23616',
  verde: '#44bd32',
  amarelo: '#f0c11a',
  amarelo2: '#e1a32a'
}
